import { render, staticRenderFns } from "./xeChartDonutSetting.vue?vue&type=template&id=9c40341a"
import script from "./xeChartDonutSetting.vue?vue&type=script&lang=js"
export * from "./xeChartDonutSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports